<!--共享库存商品列表-即共享审核-->

<template>
  <div id="siGoodsList" class="business-content-main">
    <div class="bread-nav">
      <div>您当前位置：</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客服</el-breadcrumb-item>
        <el-breadcrumb-item>共享库存</el-breadcrumb-item>
        <el-breadcrumb-item>共享审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-name">汽配编码:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchParams.code"
        placeholder="请输入汽配编码"
      ></el-input>
      <div class="search-name">商品名称:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchParams.goodsName"
        placeholder="请输入商品名称"
      ></el-input>
      <div class="search-name">车系:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchParams.autoSerise"
        placeholder="请输入车系"
      ></el-input>
      <div class="search-name">客户:</div>
         <el-autocomplete
          class="search-item"
          v-model="searchParams.entpName"
          :fetch-suggestions="querySearch"
          placeholder="客户名称"
          size="small"
          clearable
        ></el-autocomplete>
      <div class="search-name">状态:</div>
      <el-select size="small" class="search-item" v-model="searchParams.state" placeholder="请选择">
        <el-option
          v-for="item in ShareStateList"
          :key="item.Tkey"
          :label="item.TValue"
          :value="item.Tkey"
        ></el-option>
      </el-select>
      <div>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          class="search-btn"
          @click="handleSearch"
        >查询</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-refresh"
          class="search-btn"
          @click="resetSearch"
        >重置</el-button>
         <el-button
          type="danger"
          size="small"
          icon="el-icon-edit"
          class="search-btn"
          @click="openVerifySIDialog('',0,'batch')"
          v-if="permission.审核"
        >批量审核</el-button>
      </div>
    </div>
    <div class="table-ctn">
      <el-table
        :header-cell-style="{background:'#F2F6FC'}"
        :data="shareInventoryList.data"
        border=""
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"  :selectable="selectable" width="55"></el-table-column>
        <el-table-column prop="MainImg" label="商品图片" align="center" width="100px">
          <template slot-scope="scope" align="center">
             <div v-viewer="options" >
                <template>
                  <img 
                    :src="scope.row.MainImg+'?imageView2/2/w/200'" class="formImg" 
                    :data-src="scope.row.MainImg"
                  >
                </template>
              </div>
         
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="ShareNo" label="共享编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="APCode" label="汽配编码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="GoodsName" label="商品名称"></el-table-column>
        <el-table-column show-overflow-tooltip width="90px" prop="SharePrice" label="共享价格"></el-table-column>
        <el-table-column show-overflow-tooltip width="90px" prop="ShareInventory" label="共享数量"></el-table-column>
        <el-table-column show-overflow-tooltip prop="CName" label="客户名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="PhoneNum" width="110px" label="联系电话"></el-table-column>
        <el-table-column show-overflow-tooltip prop="ShareStateName" width="110px" label="状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="openSIDetailDialog(scope.row.GoodsId)"
              v-if="permission.查看"
            >查看</el-button>
            <el-button
              type="text"
              size="small"
              style="color:#f56c6c;"
              @click="openVerifySIDialog(scope.row,scope.$index,'single')"
              v-if="scope.row.ShareState==0&&permission.审核"
            >审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-ctn">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchParams.page"
        :page-size="searchParams.limit"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="shareInventoryList.totalCount"
      ></el-pagination>
    </div>
    <el-dialog title="共享审核" :close-on-click-modal="false" :visible.sync="verifySIdialogVisible">
      <div class="dialog-content">
        <el-form :model="verifySIReqData" ref="verifySIForm" label-width="85px" size="mini">
          <el-form-item label="结果" prop="state">
            <el-radio v-model="verifySIReqData.state" label="1">审核通过</el-radio>
            <el-radio v-model="verifySIReqData.state" label="0">审核不通过</el-radio>
          </el-form-item>
          <el-form-item label="平台服务费" prop="serviceFee" v-if="verifySIReqData.state=='1'&&verifyType=='single'">
            <el-input-number v-model="verifySIReqData.serviceFee" :min="0" style="width:193px;"></el-input-number>
          </el-form-item>
          <el-form-item label="交货时间" prop="deliveryConfigId" v-if="verifySIReqData.state=='1'&&verifyType=='single'">
            <el-select v-model="verifySIReqData.deliveryConfigId">
              <el-option
                v-for="item in DeliveryTimes"
                :key="item.TKey"
                :label="item.TValue"
                :value="item.TKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核结果" prop="checkResult">
            <el-input
              v-model="verifySIReqData.checkResult"
              autocomplete="off"
              type="textarea"
              placeholder="请输入审核结果"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetVerifySIForm('verifySIForm')">取 消</el-button>
        <el-button type="primary" @click="saveVerifyShareGoods('verifySIForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="共享库存详情" :visible.sync="sIDetailVisible">
      <div class="APMsg-ctn">
        <el-form ref="form" :model="shareInventoryDetail" label-width="100px">
          <div class="form-row">
            <el-form-item label="配件图片：" style="width: 100%;">
               <div v-viewer="options" class="flex" id="imgdiv">
                    <template v-for="(image,index) in shareInventoryDetail.PictureList">
                      <img 
                        :src="image+'?imageView2/2/w/200'" class="image-item " :key="index"
                        :data-src="image"
                      >
                    </template>
                </div>
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="汽配编码：" style="width: 50%">
              {{
              shareInventoryDetail.APCode
              }}
            </el-form-item>
            <el-form-item label="互换码：" style="width: 50%">
              {{
              shareInventoryDetail.GoodCode
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="汽配名称：" style="width: 50%">
              {{
              shareInventoryDetail.GoodName
              }}
            </el-form-item>
            <el-form-item label="品牌：" style="width: 50%">
              {{
              shareInventoryDetail.Brand
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="适用车型：" style="width: 50%">
              {{
              shareInventoryDetail.AutoSerise
              }}
            </el-form-item>
            <el-form-item label="分类：" style="width: 50%">
              {{
              shareInventoryDetail.ExAttribute1
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="重量：" style="width: 50%">
              {{
              shareInventoryDetail.Quality
              }}
            </el-form-item>
            <el-form-item label="颜色：" style="width: 50%">
              {{
              shareInventoryDetail.Color
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="材质：" style="width: 50%">
              {{
              shareInventoryDetail.Texture
              }}
            </el-form-item>
            <el-form-item label="单位：" style="width: 50%">
              {{
              shareInventoryDetail.Unit
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="适用车型：" style="width: 50%">
              {{
              shareInventoryDetail.AutoSerise
              }}
            </el-form-item>
            <el-form-item label="尺寸：" style="width: 50%">
              {{
              shareInventoryDetail.Size
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="备注：" style="width: 50%">
              {{
              shareInventoryDetail.GoodDesc
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="库存：" style="width: 50%">
              {{
              shareInventoryDetail.Inventory
              }}
            </el-form-item>
            <el-form-item label="共享库存：" style="width: 50%">
              {{
              shareInventoryDetail.ShareInventory
              }}
            </el-form-item>
          </div>
           <div class="form-row">
            <el-form-item label="共享价" style="width: 50%">
              {{
              shareInventoryDetail.SharePrice
              }}
            </el-form-item>
            <el-form-item label="平台服务费：" style="width: 50%">
              {{
              shareInventoryDetail.PlatformServiceFee
              }}
            </el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="交货时间：" style="width: 50%">
              {{
              shareInventoryDetail.DeliveryConfig
              }}
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
// Viewer.setDefaults({
//     Options: {
//         "inline": true,  //启用 inline 模式 默认false
//         "button": true,　　//显示右上角关闭按钮 默认true
//         "navbar": true,　　//显示缩略图导航 默认true
//         "title": true,　　//显示当前图片的标题 默认true
//         "toolbar": true,　　// 显示工具栏 默认true
//         "tooltip": true,　　// 显示缩放百分比 默认true
//         "movable": true,　　//图片是否可移动 默认true
//         "zoomable": true,　　//图片是否可缩放 默认true
//         "rotatable": true,　　//图片是否可旋转 默认true
//         "scalable": true,　　//图片是否可翻转 默认true
//         "transition": true,　　//使用css3过度 默认true
//         "fullscreen": true,　　//是否全屏 默认true
//         "keyboard": true,　　//是否支持键盘 默认true
//         "url": 'data-source' //设置大图片的URL
//     }
// });

export default {
  name: "siGoodsList",
  components: {},
  data() {
    return {
      imgcdn: this.$util.QN_URL_BASE,
      ShareStateList: [
        { Tkey: "-1", TValue: "请选择" },
        { Tkey: "0", TValue: "待审核" },
        { Tkey: "1", TValue: "审核通过" },
        { Tkey: "2", TValue: "审核不通过" },
        { Tkey: "3", TValue: "已取消共享" },
        { Tkey: "4", TValue: "已暂停共享" }
      ],
      searchParams: {
        code: "",
        goodsName: "",
        autoSerise: "",
        state: "-1",
        entpName:"",
        page: 1,
        limit: 10
      },
      shareInventoryList: {
        data: [],
        totalCount: 0 //总页数
      },
      DeliveryTimes: [{ TKey: "-1", TValue: "不限" }],
      verifySIdialogVisible: false,
      verifyType:"single",//审核操作类型：single单个；batch批量
      //审核共享库存商品请求对象
      verifySIReqData: {
        state: "1",
        checkResult: "",
        goodsId: "",
        serviceFee: 0,
        deliveryConfigId: "-1",
        index: 0
      },
      //共享库存详情对象
      shareInventoryDetail: {},
      sIDetailVisible: false,
      permission: {},
      multipleSelection: [],
      entpList: [],
      options: {
        url: 'data-src',
        zIndex: 9999
      },
    };
  },
  mounted() {
    this.getShareInventoryList();
    this.$util.getPermission("共享审核").then(res => {
      this.permission = res;
    });
  },
  methods: {
    //搜索按钮事件
    handleSearch() {
      this.searchParams.page = 1;
      this.getShareInventoryList();
    },
    resetSearch() {
      this.searchParams = {
        code: "",
        goodsName: "",
        autoSerise: "",
        state: "-1",
        entpName:"",
        page: 1,
        limit: 10
      };
    },
    handleSizeChange(val) {
      this.searchParams.page = 1;
      this.searchParams.limit = val;
      this.getShareInventoryList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getShareInventoryList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(function(g){
        return g.GoodsId;
      });
    },
    selectable(row,index){
      return row.ShareState==0;
    },
    //获取共享库存列表
    getShareInventoryList() {
      var that = this;
      this.axios
        .get("/ShareInventory/GetShareInventoryList", {
          params: that.searchParams
        })
        .then(result => {
          if (result.data.data) {
            var goodslist = [];
            result.data.data.forEach(e => {
              if (e.MainImg) {
                e.MainImg = that.imgcdn + e.MainImg;
              }
              goodslist.push(e);
            });

            that.shareInventoryList = {
              data: goodslist,
              totalCount: result.data.count
            };
          }else{
             that.shareInventoryList = {
              data: [],
              totalCount: 0
            };
          }
        });
    },
    //获取交货时间
    getDeliveryTimes() {
      var that = this;
      this.axios
        .get("/ShareInventory/GetDeliveryTimes", { hideloading: false })
        .then(result => {
          that.DeliveryTimes = that.DeliveryTimes.concat(result.data.data);
        });
    },
    //打开共享审核弹窗
    openVerifySIDialog(row, index,verifyType) {
      this.verifyType=verifyType;
      this.verifySIdialogVisible = true;
      if(verifyType=='single'){
        this.verifySIReqData.goodsIds = [row.GoodsId];
         if (this.DeliveryTimes.length == 1) {
            this.getDeliveryTimes();
          }
      }else{
        this.verifySIReqData.goodsIds= this.multipleSelection;
      }
      
      this.verifySIReqData.index = index;
      this.verifySIReqData.checkResult = "";
      this.verifySIReqData.deliveryConfigId = "-1";
     
    },
    //取消共享审核弹窗
    resetVerifySIForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs[formName].clearValidate();
      this.verifySIdialogVisible = false;
    },
    //保存审核共享商品
    saveVerifyShareGoods(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.verifySIReqData.state == "0"&&that.verifySIReqData.checkResult.length==0) {
            that.$util.errorMsg("请输入审核结果");
            return;
          }

          let index = that.verifySIReqData.index;
          let _formData = that.verifySIReqData;
          that.axios
            .post("/ShareInventory/VerifyShareInventory", _formData)
            .then(res => {
              let result = res.data;
              if (result.errcode == 0) {
                if(that.verifyType=='single'){
                    if (that.verifySIReqData.state == "0") {
                        that.shareInventoryList.data[index].ShareState = 2;
                        that.shareInventoryList.data[index].ShareStateName =
                          "审核不通过";
                      } else {
                        that.shareInventoryList.data[index].ShareState = 1;
                        that.shareInventoryList.data[index].ShareStateName =
                          "审核通过";
                      }
                }else{
                    that.getShareInventoryList();
                }
              
                that.$util.successMsg("审核成功");
                that.resetVerifySIForm(formName);
              } else {
                that.$util.errorMsg(result.errmsg);
              }
            })
            .catch(err => {
              let result = err.data;
              if (result) {
                that.$util.errorMsg(result.errmsg);
              } else {
                this.$message.error("审核失败！");
              }
            });
        }
      });
    },
    //打开共享库存详细弹窗
    openSIDetailDialog(goodsId) {
      if (this.DeliveryTimes.length == 1) {
        this.getDeliveryTimes();
      }
      var that = this;
      this.axios
        .get("/ShareInventory/GetShareGoodsDetail?goodsId=" + goodsId)
        .then(resp => {
          that.shareInventoryDetail = resp.data.data;
          var picturelist = [];
          that.shareInventoryDetail.PictureList.forEach(e => {
            picturelist.push(that.imgcdn + e);
          });
          that.shareInventoryDetail.PictureList = picturelist;
          that.sIDetailVisible = true;
        })
        .catch(err => {
          let result = err.data;
          if (result) {
            that.$util.errorMsg(result.errmsg);
          } else {
            this.$message.error("获取共享库存详细失败！");
          }
        });
    },
   querySearch(queryString, cb) {
      this.$util.searchEntp(queryString).then(data => {
        let customerList = [];
        let result=data.data;
        for (let i in result) {
          customerList.push({
            value: result[i].Name
          });
        }
        cb(customerList);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.APMsg-ctn {
  padding-left: 5px;
  height: 600px;
  overflow-y: auto;
}
.form-row {
  display: flex;
}
.APMsg-ctn .el-form-item {
  margin-bottom: 0;
  color: #000;
}
.table-title {
  .cell-item {
    width: 33.33%;
  }
  .div-table-cell {
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}
.table-main {
  .div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cell-line {
    display: flex;
    width: 100%;
  }
  .cell-item {
    padding: 0 10px;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
.image-item {
  width: 100px;
  height: 100px;
  overflow: hidden;
  margin-right: 20px;
  border: 1px solid @border3Color;
  border-radius: 5px;
  cursor: pointer;
}
.formImg{
  cursor: pointer;
  width: 70px;
  height: 70px;
}
#imgdiv{
  display: inline-block;
  // overflow: hidden;
  // overflow-x: auto;
  // width:100%;
  // white-space: nowrap;
}
/*修改滚动条样式*/
#imgdiv::-webkit-scrollbar{
  width:10px;
  height:5px;
  cursor: pointer;
  /**/
}
#imgdiv::-webkit-scrollbar-track{
  background: rgb(239, 239, 239);
  border-radius:2px;
}
#imgdiv::-webkit-scrollbar-thumb{
  background:rgb(146, 199, 255);
  border-radius:10px;
}
#imgdiv::-webkit-scrollbar-thumb:hover{
  // background: #333;
// background:rgb(146, 199, 255);
opacity: 0.6;
}
#imgdiv::-webkit-scrollbar-corner{
  background: #179a16;
}
</style>
